const allContractComments = { data: [], loading: true };

export const GetContractComments = (state = allContractComments, action) => {
  switch (action.type) {
    case "get_contractcomments":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

const populateUsers = { data: [], loading: true };

export const GetAllPopulateUsers = (state = populateUsers, action) => {
  switch (action.type) {
    case "get_populateusers":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
